import React, { useEffect, useState } from "react";

import {
  Portlet,
  PortletBody,
  PortletHeader,
  PortletHeaderToolbar
} from "../../../partials/content/Portlet";

import { DataTable, DataFilter, TablePaginationActions } from '../../../common';
import { IconButton, TablePagination, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Helmet from 'react-helmet';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { DeleteConfirmation } from "../../../common/DeleteConfirmation";
import { useLocation } from "react-router-dom";
import { adjustCurrentPage } from "../../../util";

const useStyles = makeStyles(theme => ({
  textField: {
    width: 400,
  },
}));

export default function DashboardConfigurationPage(props) {
  const classes = useStyles();
  const search = useLocation().search;
  const persist = new URLSearchParams(search).get('persist');
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);

  const {
    dashboardsFilteredData, fields, sort, dashboardListPending, dashboardDeletePending,
    filter,
    order, actions: { setSort, setOrder, dashboardList, setFilter }
  } = props;


  useEffect(() => {
    dashboardList();
    if (!persist) {
      setFilter('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let currentPage = page + 1; 
    let totalRecords = dashboardsFilteredData?.length;
    let pageSize = rowsPerPage;

    currentPage = adjustCurrentPage(currentPage, totalRecords, pageSize);
    if (page === currentPage - 1) return;
    setPage(currentPage - 1);
}, [dashboardsFilteredData]);


  const handleDashboardEdit = (dashboard) => {
    props.history.push(`/admin/dashboards/edit/${dashboard.id}`);
  }

  const handleCallBack = () => {
    const { actions: { dashboardList } } = props;
    dashboardList();
  }

  const handleDashboardDelete = (dashboard) => {
    if (dashboard) {
      const { actions: { dashboardDelete } } = props;
      dashboardDelete(dashboard.id, handleCallBack);
    }
  }

  const handleSearchInput = (value) => {
    const { actions: { setFilter } } = props;
    setFilter(value);
  }

  const handleAddDashboard = () => {
    props.history.push('/admin/dashboards/edit/new');
  }

  function configActions(rowData) {
    return (
      <div className='d-flex'>
        <IconButton
          color="primary"
          className='p-1'
          aria-label="Edit"
          onClick={() => handleDashboardEdit(rowData)}
          size="large">
          <Tooltip title="Edit">
            <EditIcon />
          </Tooltip>
        </IconButton>
        <DeleteConfirmation handleDelete={() => handleDashboardDelete(rowData)} />

      </div>
    );
  }

  function handleRefresh() {
    dashboardList();
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (<>
    <Helmet title="Dashboard Configuration" />
    <Portlet>
      <PortletHeader
        title="Dashboards"
        toolbar={
          <PortletHeaderToolbar>
            <DataFilter
              onChange={handleSearchInput}
              placeholder="Search"
              cssClass={classes.textField}
              filter={filter}
            />
          </PortletHeaderToolbar>
        }
      />
      <PortletBody>
        <DataTable
          fields={fields}
          data={dashboardsFilteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
          onAdd={handleAddDashboard}
          order={order}
          onOrder={setOrder}
          sort={sort}
          onSort={setSort}
          loading={dashboardListPending || dashboardDeletePending}
          name="Dashboard"
          handleRefresh={handleRefresh}
          showPagination={true}
          footerPagination={() => (
            <TablePagination
              rowsPerPageOptions={[10, 50, 100, 250, 500, { label: 'All', value: -1 }]}
              colSpan={fields.length + 2}
              count={dashboardsFilteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          )}

          hasActions={true}
          renderActionColumn={configActions}
        />
      </PortletBody>
    </Portlet>
  </>);
}
